// extracted by mini-css-extract-plugin
export default {"container":"EditorHeading_container__1CKZu","button":"EditorHeading_button__6SIzy"};